import { fetchWithAuth } from './config';

const getServices = async () => {
  const services = await fetchWithAuth('/services');

  return services;
};

const createService = async ({ name, description }: { name: string, description: string }) => {
  await fetchWithAuth('/services', {
    method: 'POST',
    body: JSON.stringify({ name, description }),
  });
};

const deleteService = async (serviceId: string) => {
  await fetchWithAuth(`/services/${serviceId}`, {
    method: 'DELETE',
  });
};

export {
  getServices,
  createService,
  deleteService,
};
